export default {
  getHead: () => {
    return [{ name: "학교명" }, { name: "작업명" }, { name: "안전·보건관리계획 이행 점검일" }, { name: "소속명" }, { name: "부서명" }, { name: "작성자" }];
  },
  getCol: (index, value, func) => {
    switch (index) {
    case 0:
      return func.getContent(value).stdInfo.field_name; // 학교명
    case 1:
      return func.getContent(value).stdInfo.작업명; // 작업명
    case 2:
      return func.getContent(value).inputD_1; // 점검일
    case 3:
      return func.getContent(value).stdInfo.department; // 소속명
    case 4:
      return func.getContent(value).stdInfo.section; // 부서명
    case 5:
      return func.getContent(value).stdInfo.writer_name; // 작성자
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case "학교명":
      return ["content$body.field_name*%[:default_skw]%"];
    case '작업명':
      return ["content$body.stdInfo.\"작업명\"*%[:default_skw]%"];
    case '안전·보건관리계획 이행 점검일':
      return ["content$body.inputD_1*%[:default_skw]%"];
    case "소속명":
      return ["content$body.stdInfo.department*%[:default_skw]%"];
    case "부서명":
      return ["content$body.stdInfo.section*%[:default_skw]%"];
    case "작성자":
      return ["content$body.stdInfo.writer_name*%[:default_skw]%"];
    }

    return [];
  },
};
